import { render, staticRenderFns } from "./WheelsButton.vue?vue&type=template&id=41c4101f"
import script from "./WheelsButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./WheelsButton.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports